export default __webpack_public_path__ + "static/media/school-gold.8fd4a7a7.svg";